import { tempoApi } from '@/lib/api/tempoApi';
import type { Estimation } from '@/lib/api/types/estimationScheme';

export const getEstimationsByIds = async (
  estimationIds: Set<number>,
): Promise<Record<number, Estimation>> => {
  if (estimationIds.size === 0) return {};

  const estimationIdsArray = Array.from(estimationIds);

  const response = await tempoApi().post('api/v1/item-store/estimations/bulk-fetch', {
    json: estimationIdsArray,
  });

  const estimations = await response.json<Estimation[]>();

  // Convert array to Record<number, Estimation> using id as key
  const result: Record<number, Estimation> = {};
  for (const estimation of estimations) {
    result[estimation.id] = estimation;
  }

  return result;
};
